"use strict";

var _extends = Object.assign || function (t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];

    for (var a in r) {
      Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
  }

  return t;
},
    React = require("react"),
    PropTypes = require("prop-types"),
    Button = require("./Button.js"),
    LinkButton = require("./LinkButton.js"),
    ButtonDark = React.forwardRef(function (t, e) {
  var r = t.href ? LinkButton : Button;
  return React.createElement(r, _extends({}, t, {
    ref: e,
    className: "blx-dark " + t.className
  }));
});

ButtonDark.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}, ButtonDark.defaultProps = {
  className: "",
  style: null
}, module.exports = ButtonDark;